import type { AdminDashboardData } from '@workspace/api-backend'
import { MetricCard } from '@workspace/ui/components/metric-card'
import { TimeSeriesChart } from '@workspace/ui/components/time-series-chart'
import { DashboardCard, DashboardSection } from './dashboard-card'
import { formatPercent } from './dashboard-format'

function formatDuration(seconds: number): string {
  const m = Math.floor(seconds / 60)
  const s = seconds % 60
  return `${m}m ${s}s`
}

export function EngagementSection({ data }: { data: AdminDashboardData }) {
  const { engagement } = data
  const voted = engagement.feedback.helpful + engagement.feedback.notHelpful
  return (
    <DashboardSection title="Engagement">
      <div className="grid gap-4 lg:grid-cols-2">
        <DashboardCard title="Data room sessions per day" subtitle="Investor visits to data rooms">
          <TimeSeriesChart
            data={engagement.byDay}
            series={[
              { key: 'sessions', label: 'Sessions', color: 'var(--chart-1)' },
              {
                key: 'uniqueVisitors',
                label: 'Unique visitors',
                color: 'var(--chart-2)',
                kind: 'line',
              },
            ]}
          />
        </DashboardCard>
        <div className="grid gap-4 sm:grid-cols-2">
          <MetricCard
            label="Avg. data room session"
            value={formatDuration(engagement.avgSessionSeconds)}
          />
          <MetricCard
            label="Feedback received"
            value={engagement.feedback.total.toLocaleString()}
          />
          <MetricCard
            label="Feedback helpful rate"
            value={voted > 0 ? formatPercent(engagement.feedback.helpful / voted) : '—'}
            subtitle={`${engagement.feedback.helpful} helpful / ${engagement.feedback.notHelpful} not`}
          />
        </div>
      </div>
    </DashboardSection>
  )
}
